import React, { ReactNode } from "react";
import { format } from "date-fns";

import { ReportAnswer } from "../../../../graphql/types";

import useTranslations from "../../../../hooks/useTranslations";

import Avatar from "../../../wombat-ui/Avatar";

type AnswerProps = {
  answer: ReportAnswer;
  answerAs: ReactNode;
  withComment?: boolean;
  comment?: ReactNode;
};

const Answer: React.FC<AnswerProps> = ({
  answer,
  answerAs,
  withComment,
  comment,
}) => {
  const t = useTranslations();

  return (
    <div className="flex flex-col col-span-1 text-sm bg-white rounded shadow text-dark-100">
      <div className="flex items-center px-6 py-3 space-x-4 border-b border-light-300 bg-light-0">
        <Avatar
          size={6}
          src={answer.user.avatar}
          type="user"
          alt={`${answer.user.name} profile picture`}
        />
        <div className="flex justify-between flex-grow font-semibold text-primary-700">
          {answer.user.name}
          <span className="ml-1 text-xs font-normal text-light-900">
            {format(new Date(answer.updatedAt), t("dateFormat") as string)}
          </span>
        </div>
      </div>
      <div className="flex flex-wrap px-6 py-4 space-x-2 text-sm font-normal text-dark-500">
        {answerAs}
      </div>
      {answer.timeSpent > 0 && (
        <div className="px-6 pb-4">
          <h6 className="text-xs font-medium text-light-900">
            {t("reports.timeSpentInHour")}:
          </h6>
          <div className="flex flex-wrap space-x-2 text-xs font-normal text-dark-300">
            {answer.timeSpent}
          </div>
        </div>
      )}
      {withComment && (
        <div className="px-6 pb-4">
          <h6 className="text-xs font-medium text-light-900">
            {t("reports.comments")}:
          </h6>
          <div className="flex flex-wrap space-x-2 text-xs font-normal text-dark-300">
            {comment ? comment : <em> {t("reports.noComments")}</em>}
          </div>
        </div>
      )}
    </div>
  );
};

export default React.memo(Answer);
